import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { CamerasParamList } from '../../../typings/Params';
import DownloadTagsDropdown from '../../../components/Filters/Cameras/Downloads/DownloadTagsDropdown';
import DownloadCameraDropdown from '../../../components/Filters/Cameras/Downloads/DownloadCameraDropdown';
import { useAuth } from '../../../context/Auth';
import DownloadUserDropdown from '../../../components/Filters/Cameras/Downloads/DownloadUserDropdown';
import ActingBodyDropdown from '../../../components/Filters/Cameras/ActingBodyDropdown';
import ActingBodyUnitsDropdown from '../../../components/Filters/Cameras/ActingBodyUnitsDropdown';

interface Props {
    filters: CamerasParamList['Downloads'];
    setFilters: React.Dispatch<React.SetStateAction<CamerasParamList['Downloads']>>;
    textFilter: string;
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const { user: authenticatedUser } = useAuth();

    const navigation = useNavigation<NavigationProp<RouteProp<CamerasParamList, 'Downloads'>>>();

    const [tagsIds, setTagsIds] = useState<number[]>(filters.tagsIds ?? []);
    const [userId, setUserId] = useState<number>(filters.userId ?? 0);
    const [userText, setUserText] = useState<string>('');
    const [cameraId, setCameraId] = useState<string>(filters.cameraId ?? '');
    const [cameraText, setCameraText] = useState<string>('');
    const [actingBodyId, setActingBodyId] = useState<number>(filters.actingBodyId ?? 0);
    const [actingBodyUnitIds, setActingBodyUnitIds] = useState<number[]>(filters.actingBodyUnitIds ?? []);

    const handleCleanFilter = () => {
        setTextFilter('');
        setTagsIds([]);
        setUserId(0);
        setUserText('');
        setCameraId('');
        setCameraText('');
        setActingBodyUnitIds([]);
        setActingBodyId(0);
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            tagsIds: tagsIds.length > 0 ? tagsIds : undefined,
            userId: userId !== 0 ? userId : undefined,
            cameraId: cameraId !== '' ? cameraId : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
            actingBodyUnitIds: actingBodyUnitIds.length > 0 ? actingBodyUnitIds : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            tagsIds: tagsIds.length > 0 ? tagsIds : undefined,
            userId: userId !== 0 ? userId : undefined,
            cameraId: cameraId !== '' ? cameraId : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
            actingBodyUnitIds: actingBodyUnitIds.length > 0 ? actingBodyUnitIds : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            {(authenticatedUser?.isAdmin || authenticatedUser?.permissions.camera_watch_download_all_acting_bodies) &&
                <ActingBodyDropdown
                    value={actingBodyId}
                    setValue={setActingBodyId}
                    includeAllOption={true}
                    zIndex={5}
                />
            }

            {(authenticatedUser?.isAdmin || authenticatedUser?.permissions.camera_watch_download_acting_body_units || authenticatedUser?.permissions.camera_watch_download_all_acting_bodies) &&
                <ActingBodyUnitsDropdown
                    value={actingBodyUnitIds}
                    actingBodyId={(authenticatedUser?.isAdmin || authenticatedUser?.permissions.camera_watch_download_all_acting_bodies) ? actingBodyId : authenticatedUser?.actingBodyUnit.actingBodyId ?? 0}
                    setValue={setActingBodyUnitIds}
                    zIndex={4}
                />
            }
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
            <DownloadTagsDropdown
                value={tagsIds}
                setValue={setTagsIds}
                zIndex={3}
            />
            <DownloadUserDropdown
                value={userId}
                setValue={setUserId}
                zIndex={2}
                userText={userText}
                setUserText={setUserText}
                actingBodyId={actingBodyId}
                actingBodyUnitIds={actingBodyUnitIds}
            />
            <DownloadCameraDropdown
                value={cameraId}
                setValue={setCameraId}
                zIndex={1}
                cameraText={cameraText}
                setCameraText={setCameraText}
            />
        </Filters>
    );
}


export default Filter;
